module.exports = __webpack_public_path__ + "static/media/softgel.2f97a56e.svg";